export const ChangeOwnerIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M7.5 8.25C9.15685 8.25 10.5 6.90685 10.5 5.25C10.5 3.59315 9.15685 2.25 7.5 2.25C5.84315 2.25 4.5 3.59315 4.5 5.25C4.5 6.90685 5.84315 8.25 7.5 8.25Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.25 15.75C2.25 12.8505 4.60051 10.5 7.5 10.5C8.47 10.5 9.37847 10.763 10.1578 11.2216"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 12.75H16.5M16.5 12.75L14.625 10.875M16.5 12.75L14.625 14.625"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
